import './App.css';
import Footer from './clients/components/Footer/Footer';
import Header from './clients/components/Header/Header';
import WebsiteMainPage from './clients/components/MainWebsitePage/WebsiteMainPage';


function App() {
  return (
    <>
      <Header />
      <WebsiteMainPage />
      <Footer />
    </>
  );
}

export default App;
